import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const contactUs = createAsyncThunk("contactUs/form", async (data) => {
    const response = await ApiService.post("/createClient", data); // Assume it returns { token }
    return response;
  });